import { useState } from "react";
import { PropTypes } from "prop-types";
import { Storage } from "aws-amplify";
import { Alert, Button, Typography } from "@mui/material";
import "./csv-picker.scss";

const propTypes = {
  cohorts: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const CsvPicker = ({ cohorts }) => {
  const [message, setMessage] = useState("");

  const handleFileUpload = async (e) => {
    setMessage("");
    const file = e.target.files[0];
    try {
      await Storage.put(
        `alumni-csv/${new Date().getTime()}-${file.name}`,
        file,
        {
          contentType: file.type,
        }
      );
      setMessage(
        "Successfully uploaded file. It may take a few minutes before the new alumni profiles appear."
      );
    } catch (error) {
      setMessage("Error uploading file.");
    }
  };

  return (
    <div className="csv-picker">
      <Typography variant="h6" color="primary" className="title">
        Upload Alumni
      </Typography>
      {cohorts.length <= 0 && (
        <Alert className="alert" severity="warning">
          Add cohorts first before uploading alumni
        </Alert>
      )}
      {message && <Alert className="alert">{message}</Alert>}
      <label htmlFor="file-input">
        <input
          type="file"
          accept="text/csv"
          id="file-input"
          hidden
          onChange={handleFileUpload}
        />
        <Button
          disabled={cohorts.length <= 0}
          fullWidth
          size="large"
          variant="contained"
          component="span"
          color="secondary"
          className="upload-button"
        >
          Pick a csv file to upload
        </Button>
      </label>
    </div>
  );
};

CsvPicker.propTypes = propTypes;

export default CsvPicker;
